<template>
  <v-toolbar
    text
    dark
    color="light-blue darken-4"
    :flat="isFlat"
    class="baseToolbar"
  >
    <v-toolbar-title class="baseToolbar_title">
      {{ toolbarTitle }}
    </v-toolbar-title>
    <!-- <v-divider class="mx-2 hidden-sm-and-down" inset vertical></v-divider> -->
    <v-spacer></v-spacer>
    <slot name="toolbarSearch"></slot>
    <v-spacer></v-spacer>
    <slot name="toolbarBtn" class="toolbarBtn"></slot>
  </v-toolbar>
</template>
<script>
export default {
  props: {
    toolbarTitle: {
      type: String,
      required: true,
      default: () => "Title"
    },
    isFlat: {
      type: Boolean,
      default: () => false
    }
  }
};
</script>
<style lang="scss">
@media screen and (max-width: 600px) {
  .baseToolbar {
    height: auto !important;

    &_title {
      margin-top: 5px;
      margin-bottom: 10px;
    }

    .v-toolbar__content {
      flex-wrap: wrap !important;
      height: auto !important;

      .v-btn {
        width: 100%;
        margin-bottom: 10px !important;
        margin-top: 10px !important;
      }

      .v-input {
        width: 100%;
      }
    }
  }
}
</style>
